import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const storiesgcc = () => {
  return (
    <div className="normal_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Success Stories By Our Mobile App Development Company in Saudi
              Arabia
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              TekRevol has earned a credible position in the global tech
              industry due to its next-gen mobile application development
              products that are designed to cater to businesses around the
              world. Many businesses using our high-tech are continuously
              observing immense growth in their ROI while increasing their
              overall revenue. Here are a few popular solutions that we have
              showcased below for you to witness reliably as a mobile app
              development company in Saudi Arabia.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default storiesgcc;
